import { createContext, useContext, useState, useEffect, useMemo, ReactNode, Dispatch, SetStateAction } from 'react';
import { engine, getUserId } from '../../Utilities';

interface Settings {
    hasAccessPermission?: string[]
}

interface OnboardingContextType {
    hasAccess: boolean;
    loading: boolean;
    settings: Settings | null;
    setSettings: Dispatch<SetStateAction<Settings | null>>
}

export const ACCESS_ROLES = ['ROLE_OWNER'];

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

const Provider = OnboardingContext.Provider as any;

export function OnboardingProvider({ children }: { children: ReactNode }) {
    const [settings, setSettings] = useState<Settings | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        engine().get("/api/onboarding-setting")
            .then(res => {
                if (res.data && res.status === 200) setSettings(res.data.data);
            })
            .finally(() => setLoading(false));
    }, []);

    const hasAccess = useMemo(() => {
        const loginUserRole: string | null = localStorage.getItem("currentUserRole");
        const isPrivilegedRole: boolean = loginUserRole ? ACCESS_ROLES.includes(loginUserRole) : false;
        const hasPermission = settings?.hasAccessPermission?.includes(String(getUserId())) ?? false;
        return isPrivilegedRole || hasPermission;
    }, [settings]);

    return (
        <Provider value={{ hasAccess, loading, settings, setSettings }}>
            {children}
        </Provider>
    );
}

export function useOnboarding() {
    const ctx = useContext(OnboardingContext);
    if (!ctx) throw new Error('useOnboarding must be used within OnboardingProvider');
    return ctx;
}